/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import i18n from "data/lang/i18n";
import { SVGIcons } from "cms/icons/svg-icons";
import { Logger } from "cms/utils/log/logger";

export const modelItems = {
    "model.page": {
        img: <SVGIcons.common.Page/>,
        name: i18n.t("Model.page"),
    },
    "model.homepage": {
        img: <SVGIcons.common.Home/>,
        name: i18n.t("Model.homepage"),
    },
    "model.alert": {
        img: <SVGIcons.models.Alert/>,
        name: i18n.t("Model.alert"),
    },
    "model.bylaw": {
        img: <SVGIcons.models.Bylaw/>,
        name: i18n.t("Model.bylaw"),
    },
    "model.committee": {
        img: <SVGIcons.models.Committee/>,
        name: i18n.t("Model.committee"),
    },
    "model.development-application": {
        img: <SVGIcons.models.DevApplication/>,
        name: i18n.t("Model.devApplication"),
    },
    "model.dispute": {
        img: <SVGIcons.models.DisputeModel />,
        name: i18n.t("Model.dispute"),
    },
    "model.dpa": {
        img: <SVGIcons.models.DevPermitArea/>,
        name: i18n.t("Model.dpa"),
    },
    "model.event": {
        img: <SVGIcons.models.Event/>,
        name: i18n.t("Model.event"),
    },
    "model.licence": {
        img: <SVGIcons.models.Licence/>,
        name: i18n.t("Model.licence"),
    },
    "model.meeting": {
        img: <SVGIcons.models.Meeting/>,
        name: i18n.t("Model.meeting"),
    },
    "model.neighbourhood": {
        img: <SVGIcons.models.Neighbourhood/>,
        name: i18n.t("Model.neighbourhood"),
    },
    "model.news": {
        img: <SVGIcons.models.News/>,
        name: i18n.t("Model.news"),
    },
    "model.notice": {
        img: <SVGIcons.models.Advisory/>,
        name: i18n.t("Model.notice"),
    },
    "model.permit": {
        img: <SVGIcons.models.Permit/>,
        name: i18n.t("Model.permit"),
    },
    "model.report": {
        img: <SVGIcons.models.Report/>,
        name: i18n.t("Model.report"),
    },
    "model.report-section": {
        img: <SVGIcons.models.ReportSection/>,
        name: i18n.t("Model.reportSection"),
    },
    // 'model.simplicity-fields-test': {
    //     img: <SVGIcons.models.Report />,
    //     name: 'simplicity fields test',
    // },
    // 'model.simplicity-embeds-test': {
    //     img: <SVGIcons.models.Report />,
    //     name: 'simplicity embeds test',
    // },
    // 'model.simplicity-assets-test': {
    //     img: <SVGIcons.models.Report />,
    //     name: 'simplicity assets test',
    // },
    "model.integration": {
        img: <SVGIcons.models.Integration/>,
        name: i18n.t("Model.integration"),
    },
    "model.story": {
        img: <SVGIcons.models.Story/>,
        name: i18n.t("Model.story"),
    },
    "model.service": {
        img: <SVGIcons.models.Services/>,
        name: i18n.t("Model.services"),
    },
    // 'model.blog': {  // duplicate needed?
    //     img: <SVGIcons.models.Story />,
    //     name: i18n.t('Model.story'),
    // }
};

export const getModelTypesList = () => {
    const models = [];
    for (const [key, value] of Object.entries(modelItems)) {
        // Logger.debug(`${key}: ${value}`)
        models.push({
            type: key,
            name: value.name,
            image: value.img
        });
    }
    return models;
};
export const getModelName = (type) => {
    const model_types = getModelTypesList();
    const model = model_types.find((element) => element.type === type);
    return model?.name;
};

export const event_models = {
    "model.event": {
        img: <SVGIcons.models.Event/>,
        name: i18n.t("Model.event"),
    },
    "model.meeting": {
        img: <SVGIcons.models.Meeting/>,
        name: i18n.t("Model.meeting"),
    },
};
export const event_categories = {
    "event.category.all": {
        name: "All"
    },
    "model.mayor": {
        name: "Mayor and Council appearances"
    },
    "model.council": {
        name: "Council meetings and public hearings"
    },
    "model.volunteer": {
        name: "Volunteer Opportunity"
    },
    "model.hope-house": {
        name: "Open House"
    },
    "model.performance": {
        name: "Performance"
    },
    "model.workshop": {
        name: "Workshop"
    },
    "model.public-gathering": {
        name: "Public Gathering"
    },
};

export const getEventModelList = () => {
    const categories = [];
    for (const [key, value] of Object.entries(event_models)) {
        Logger.debug(`${key}: ${value}`);
        categories.push({
            type: key,
            name: value.name,
            image: value.img
        });
    }
    return categories;
};

export const getEventCategoryList = () => {
    const categories = [];
    for (const [key, value] of Object.entries(event_categories)) {
        Logger.debug(`${key}: ${value}`);
        categories.push({
            type: key,
            name: value.name,
        });
    }
    return categories;
};
export const getEventCategory = (type) => {
    const categories = getEventCategoryList();
    const category = categories.find((element) => element.type === type);
    return category?.name;
};
export const getEventCategories = (type) => {
    const categories = getEventCategoryList();
    const category = categories.find((element) => element.type === type);
    return category?.name;
};
